import styled, { css } from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;

  h1 {
    margin-bottom: 2rem;
  }

  .profile-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .sheet-model {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h3 {
      color: #00000080;
    }
  }
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem 5rem;
  margin-bottom: 2rem;
`;

export const RowContent = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

export const PageHeader = styled.div`
  padding: 3.8rem 5.6rem;
  height: 16rem;

  display: flex;
  flex-direction: column;
  justify-content: center;

  background: #242424;

  @media (max-width: 1024px) {
    padding: 2rem 4rem;
  }

  @media (max-width: 425px) {
    padding: 2rem;
  }
`;

type HeaderWrapperProps = {
  secondary?: boolean;
};

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  width: 100%;

  @media (max-width: 768px) {
    display: flex;
  }

  @media (max-width: 1024px) {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    flex-direction: row;
    justify-content: space-between;

    ${({ secondary }) =>
      secondary &&
      css`
        flex-direction: column;
        align-items: flex-start;
      `}
  }

  @media (max-width: 425px) {
    flex-direction: column;
    height: 100%;
  }
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
  letter-spacing: 1.25px;

  @media (max-width: 1024px) {
    width: 48%;
  }
  @media (max-width: 425px) {
    width: fit-content;
  }
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 425px) {
    display: none;
  }
`;

type InfoProps = {
  hide?: boolean;
};

export const InfoButton = styled.button<InfoProps>`
  background: transparent;
  font-size: 0;

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const Info = styled.div`
  display: flex;
  margin-top: 1.4rem;

  @media (max-width: 1024px) {
    margin-top: 0rem;
  }

  /* @media (max-width: 1024px) {
    width: 48%;
  } */

  @media (max-width: 425px) {
    width: fit-content;
  }
`;

export const InfoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.8rem;
  margin-right: 3rem;

  p {
    margin-left: 0.4rem;
  }
`;

export const Container = styled.div`
  padding: 2rem 4rem;

  @media (max-width: 768px) {
    padding: 2rem;
  }

  h1 {
    color: white;
  }

  form {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;

    .form-inputs {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;

      gap: 2.5rem 4.5rem;

      max-width: 102.6rem;

      @media (max-width: 1024px) {
        grid-template-columns: 1fr 1fr;
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }

      margin-bottom: 2.5rem;
    }

    .full-row-input {
      max-width: 102.6rem;

      div {
        border-radius: 2rem;
      }
    }
  }
`;

export const FormSection = styled.fieldset`
  display: grid;

  grid-template-rows: fit-content 1fr;
  align-items: center;
  border: none;

  width: 100%;

  label {
    color: white;
    height: fit-content;

    font-weight: bold;
    padding-bottom: 0.5rem;
    font-size: 1.5rem;
    margin: 0 1.8rem;
  }

  textarea {
    width: 100%;
    text-align: center;
    height: 20rem;
    font-size: 1.6rem;
    font-family: sans-serif;
  }

  div {
    height: 3.8rem;
    padding: 0 1.5rem;

    input {
      font-size: 1.5rem;
    }
  }

  p {
    color: red;
  }
`;

export const InputTimeFormSection = styled.fieldset`
  display: grid;

  grid-template-rows: fit-content 1fr;
  align-items: center;
  border: none;

  width: 100%;

  label {
    color: white;
    height: fit-content;

    font-weight: bold;
    padding-bottom: 0.5rem;
    font-size: 1.5rem;
    margin: 0 1.8rem;
  }

  textarea {
    width: 100%;
    text-align: center;
    height: 20rem;
    font-size: 1.6rem;
    font-family: sans-serif;
  }

  div {
    height: 3.8rem;

    input {
      font-size: 1.5rem;
    }
  }

  p {
    color: red;
  }
`;

export const FormSelect = styled.fieldset`
  display: grid;

  grid-template-rows: fit-content 1fr;
  align-items: center;
  border: none;

  width: 100%;

  label {
    color: white;
    height: fit-content;

    font-weight: bold;
    padding-bottom: 0.5rem;
    font-size: 1.5rem;
    margin: 0 1.8rem;
  }

  div {
    border-radius: 2rem;
  }
`;

export const FirstScreenHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const FinishTrainingButton = styled.button.attrs({ type: 'button' })`
  width: 31.7rem;
  height: 4.4rem;
  background: #ffdf22;
  border-radius: 2.5rem;

  font-size: 1.8rem;
  font-weight: bold;

  @media (max-width: 1024px) {
    width: 48%;
  }

  @media (max-width: 425px) {
    width: 31.7rem;
  }

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;
